import { Admin } from '../types/user.types';

export const canReconcileTerminals = (admin?: Admin | null) =>
  !!admin &&
  (admin.isSuper ||
    admin.roles.some((role) => role === 'OWNER' || role === 'FINANCE'));

export const receiptMoney = (amount: number) =>
  `₦${amount.toLocaleString('en-NG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const receiptDate = (value?: string | null) =>
  value
    ? new Date(value).toLocaleString('en-NG', {
        timeZone: 'Africa/Lagos',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }) + ' WAT'
    : 'Not recorded';

export const receiptError = (error: unknown) => {
  const message = (
    error as {
      response?: { data?: { message?: string | string[] } };
      message?: string;
    }
  )?.response?.data?.message;
  return Array.isArray(message)
    ? message.join(' ')
    : message ||
        'This action could not be completed. Refresh the receipt before trying again.';
};

export const receiptLabels: Record<string, string> = {
  UNMATCHED: 'Unmatched',
  LINKED: 'Linked',
  REVERSED: 'Reversed',
  REVIEW_REQUIRED: 'Needs review',
  PENDING: 'Queued',
  SENDING: 'Sending',
  ACCEPTED: 'Accepted by SMS provider',
  FAILED: 'Rejected before acceptance',
  UNKNOWN: 'Outcome uncertain — investigate',
  CANCELED: 'Canceled before dispatch',
};

export function receiptPageParams(params: URLSearchParams) {
  const next = new URLSearchParams();
  const page = Number(params.get('page'));
  next.set(
    'page',
    Number.isInteger(page) && page > 0 && page <= 100000 ? String(page) : '1'
  );
  const count = params.get('count') || '25';
  next.set('count', ['10', '25', '50'].includes(count) ? count : '25');
  const state = params.get('state') || 'UNMATCHED';
  next.set(
    'state',
    ['UNMATCHED', 'LINKED', 'REVERSED', 'REVIEW_REQUIRED', 'ALL'].includes(
      state
    )
      ? state
      : 'UNMATCHED'
  );
  const sort = params.get('sort') || 'newest';
  next.set(
    'sort',
    ['newest', 'amount-asc', 'amount-desc'].includes(sort) ? sort : 'newest'
  );
  if (/^[1-9]\d*$/.test(params.get('kitchenId') || ''))
    next.set('kitchenId', params.get('kitchenId')!);
  const search = params.get('search')?.trim().slice(0, 100);
  if (search) next.set('search', search);
  return next;
}
